import { render } from "./Inventory.vue?vue&type=template&id=4880e1ce"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=4880e1ce&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__